import { createFileRoute } from '@tanstack/react-router'
import { CompanyTags } from '@/features/company-tags'

export const Route = createFileRoute('/_authenticated/company-tags')({
  component: CompanyTags,
})
